import React, { useState } from 'react';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import { getPropValue, isTodayOrFutureDate } from '../crud/utils';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { format } from 'date-fns';
import { Round } from '../crud/utils';
import { t } from "./../i18n"
import useApp from './../AppContext';
import { addNotification } from '../Components/ToastNotifications';

function CalendarEvent(props) {
    const app = useApp();
    const [role] = useState(props.userApp.sessionToken?.Role);
    const [language] = useState(props.userApp.sessionToken?.Language);
    const [contextMenu, setContextMenu] = useState(null);
    const [hovered, setHovered] = useState(false);

    const handleClose = () => {
        setContextMenu(null);
        props.setIsEventContextMenuOpen(false);
    };

    async function handContextMenu(action, bookingId) {
        handleClose();

        if (action === "Accepted" || action === "cancel") {
            addNotification(action);
        }

        props.handContextMenu(action, bookingId, null);
    }

    return (
        <>
            {!props.isDisabled && (
                <>
                    {hovered && !contextMenu && (
                        <Box
                            className='bubble-for-event-day'
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            sx={{
                                position: 'absolute',
                                top: "27px",
                                left: `calc(${props.positionLeft} + 90px)`,
                                zIndex: 9999,
                                padding: '10px 14px',
                                borderRadius: '11px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                fontSize: '14px',
                                color: app.theme === 'dark' ? 'var(--text-secondary)' : '#333',
                                backgroundColor: app.theme === 'dark' ? 'var(--bg-tertiary)' : 'white',
                                "::after": {
                                    content: '""',
                                    position: 'absolute',
                                    left: -10,
                                    top: '20px',
                                    width: 0,
                                    height: 0,
                                    borderTop: '10px solid transparent',
                                    borderBottom: '10px solid transparent',
                                    borderRight: app.theme === 'dark' ? '10px solid var(--bg-tertiary)' : '10px solid white'
                                }

                            }}
                        >
                            <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" padding="5px 5px 10px 5px" gap={3} sx={{ backgroundColor: 'transparent' }}>
                                <Typography variant="body2" fontWeight="bold" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                    <i className="bi bi-clock" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                    {format(props.Ymsbook.FromDate, "HH:mm")}  {(!props.Ymsbook.ToDate || isNaN(props.Ymsbook.ToDate)) ? '' : ` - ${format(new Date(props.Ymsbook.ToDate), 'HH:mm')}`}
                                </Typography>
                                <Box display="flex" alignItems="center" gap={1} sx={{ backgroundColor: 'transparent' }}>
                                    <span className="event-status-text" style={{ backgroundColor: props.bgColor, color: props.dotColor, padding: "5px 10px", borderRadius: '22px' }}> {props.statusName}</span>
                                </Box>
                            </Box>
                            <Typography variant="body2" fontWeight="bold" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                <i className="bi bi-truck" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                <span>{props.Ymsbook.SupDescr || t("calendarEvent.withOutSupplier", language)}</span>&nbsp;
                                {props.Ymsbook.SupNameShort && (<span>({props.Ymsbook.SupNameShort})</span>)}
                            </Typography>
                            {props.Ymsbook.Yms3pl1.Descr1 && (
                                <Typography variant="body2" fontWeight="bold" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                    <i className="bi bi-truck-front" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                    <span>{props.Ymsbook.Yms3pl1.Descr1}</span>
                                </Typography>
                            )}

                            {props.Ymsbook.ArrivalId && (
                                <Typography variant="body2" fontWeight="bold" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                    <i className="bi bi-box-arrow-in-right" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                    Arrival ID: {props.Ymsbook.ArrivalId}
                                </Typography>
                            )}
                            {props.Ymsbook.CapacityMinutes && (() => {
                                let decimals = Number("0" || 0);
                                return (
                                    <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                        <i className="bi bi-hourglass-split" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                        {t("calendarEvent.duration", language)}: {Round(props.Ymsbook.CapacityMinutes, decimals)} {t("ModalBooking.minutesCapitalized", language)}
                                    </Typography>
                                );
                            })()}
                            {props.Ymsbook.rampNumber && <Typography variant="body2" color="textSecondary" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                <i className="bi bi-geo-alt" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                {t("calendarEvent.ramp", language)}: {props.Ymsbook.rampNumber}
                            </Typography>}
                            <Typography variant="body2" color="textSecondary" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                <i className="bi bi-car-front" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                {t("calendarEvent.plate", language)}:{getPropValue(props.Ymsbook, "YmsTrk1.LicenseNo")}
                            </Typography>

                            {props.Ymsbook.DriverId && (
                                <Typography variant="body2" color="textSecondary" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                    <i className="bi bi-person-lines-fill" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                    {t("calendarEvent.driver", language)}: {getPropValue(props.Ymsbook, "YmsDri1.Name1")}
                                </Typography>
                            )}
                            {props.Ymsbook.Phone && (
                                <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                    <i className="bi bi-telephone" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                    {t("calendarEvent.phone", language)}: {props.Ymsbook.Phone}
                                </Typography>
                            )}
                            {props.YmsbookTask && props.YmsbookTask.length > 0 && (
                                <Box sx={{ mt: 1, mb: 1, p: 1, borderRadius: '6px', backgroundColor: app.theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)', width: '100%' }}>
                                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5, color: app.theme === 'dark' ? 'var(--text-secondary)' : '#444', textAlign: 'left' }}>
                                        <i className="bi bi-list-task" style={{ marginRight: "8px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                        {props.YmsbookTask.length <= 1
                                            ? t("ModalBooking.taskLabel", language)
                                            : t("ModalBooking.actionsHeader", language)
                                        }
                                        &nbsp;
                                        ({props.YmsbookTask.length})
                                    </Typography>
                                    {props.YmsbookTask.map((task, index) => (
                                        <Box key={task.BookingTaskId || index} sx={{
                                            py: 0.75,
                                            ...(index > 0 && {
                                                borderTop: '1px solid',
                                                borderColor: app.theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                                            })
                                        }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                                <Box sx={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: 0.5
                                                }}>
                                                    <Box sx={{
                                                        width: '3px',
                                                        height: '14px',
                                                        borderRadius: '2px',
                                                        backgroundColor: 'var(--color-main-background)'
                                                    }} />
                                                    <Typography variant="body2" sx={{
                                                        color: app.theme === 'dark' ? '#e3a8c0' : 'var(--color-main-background)',
                                                        fontSize: '0.813rem',
                                                        fontWeight: 600
                                                    }}>
                                                        {task.YmsTas1.Descr1}
                                                    </Typography>
                                                </Box>
                                                <Typography variant="caption" sx={{
                                                    color: app.theme === 'dark' ? '#9ca3af' : '#6b7280',
                                                    fontSize: '0.75rem'
                                                }}>
                                                    {task.YmsCat1.Descr1}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', gap: 2, fontSize: '0.75rem' }}>
                                                <span style={{ color: 'var(--text-secondary)' }}>
                                                    <i className="bi bi-columns-gap" style={{ fontSize: '11px', marginRight: '4px', color: "var(--text-secondary)" }}></i>
                                                    {task.Pallets || 0} {t("ModalBooking.palletCountTitleForm", language)}
                                                </span>
                                                <span style={{ color: 'var(--text-secondary)' }}>
                                                    <i className="bi bi-box-seam" style={{ fontSize: '11px', marginRight: '4px', color: "var(--text-secondary)" }}></i>
                                                    {task.CountOfItems || 0} {t("ModalBooking.itemCountTitleForm", language)}
                                                </span>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            )}
                            <Typography variant="body2" color="textSecondary" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                <i className="bi bi-file-earmark-text" style={{ marginRight: "5px", color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}></i>
                                {props.Ymsbook.BookingId}
                            </Typography>
                        </Box>
                    )}
                </>
            )
            }
            <div
                style={{
                    position: 'absolute',
                    top: props.positionTop,
                    left: props.positionLeft,
                    width: '80px',
                    minHeight: '98px',
                    height: props.height,
                    zIndex: hovered && !contextMenu ? 9997 : 8,
                    pointerEvents: props.isDisabled ? 'none' : 'auto',              

                }}
                className='hover-booking-animation'
                onMouseEnter={() => {
                    setHovered(true);
                    if (props.onHoverChange) props.onHoverChange(true, props.Ymsbook.BookingId);
                }}
                onMouseLeave={() => {
                    setHovered(false);
                    if (props.onHoverChange) props.onHoverChange(false, props.Ymsbook.BookingId);
                }}
            >
            <div
                key={props.Ymsbook.BookingId}
                className={`calendar-event rounded-md shadow-sm ${props.selected ? "animated-event" : ""}`}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: props.height,
                    width: "80px",
                    color: app.theme === 'dark' ? 'var(--text-secondary)' : '#333',
                    opacity: props.isDisabled ? "0.4" : "1",
                    borderTop: `4px solid  ${!props.isDisabled ? props.dotColor : '#8D97B0'}`,
                    borderRadius: "11px",
                    zIndex: hovered && !contextMenu ? 9998 : 9,
                    overflow: props.isDisabled ? "hidden" : "auto",
                    pointerEvents: props.isDisabled ? 'none' : 'auto',
                    cursor: props.isDisabled ? 'not-allowed' : 'pointer'
                }}
                id={`event-${props.Ymsbook.BookingId}`}
                onContextMenu={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setContextMenu({
                        mouseX: event.clientX,
                        mouseY: event.clientY,
                    })
                    props.setIsEventContextMenuOpen(true);
                }}
            >
                {!props.isDisabled ? (
                    <>
                        <Box className="calendar-status-in-day" display="flex" alignItems="center">
                            <>
                                {/* <span className="event-status-text" style={{ backgroundColor: props.dotColor, padding: "6px", borderRadius: '22px' }}></span> */}
                                <div><span style={{ fontWeight: '700' }}>{props.Ymsbook.SupNameShort || props.Ymsbook.SupDescr || t("calendarEvent.withOutSupplier", language)}</span></div>
                            </>
                            {/* <Typography variant="body4" color="textSecondary">
                                <i className="bi bi-clock" style={{ marginRight: "5px" }}></i>
                                {format(props.Ymsbook.FromDate, "HH:mm")}
                                {(!props.Ymsbook.ToDate || isNaN(props.Ymsbook.ToDate)) ? '' : ` - ${format(new Date(props.Ymsbook.ToDate), 'HH:mm')}`}
                            </Typography> */}
                            {props.Ymsbook.CapacityMinutes && (
                                <Typography variant="body4" color="textSecondary">
                                    <i className="bi bi-hourglass-split" style={{ marginRight: "5px" }}></i>
                                    {Round(props.Ymsbook.CapacityMinutes, 0)}
                                </Typography>
                            )}
                            {props.YmsbookTask && props.YmsbookTask.length > 0 && (
                                <div style={{ width: '100%' }}>
                                    <Box sx={{
                                        mt: 0.5,
                                        p: 0.5,
                                        borderRadius: '6px',
                                        backgroundColor: app.theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
                                        width: '100%',
                                        // outline: '2px solid  var(--color-secondary-background)',
                                    }}>
                                        <Box sx={{
                                            fontSize: '11px',
                                            lineHeight: '1.2',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            flexDirection: 'column',
                                            gap: 0.1,
                                        }}>
                                            <Box>
                                                <i className="bi bi-columns-gap" style={{ marginRight: "5px" }}></i>
                                                <span>{props.YmsbookTask.reduce((sum, task) => sum + (task.Pallets || 0), 0)}  {t("ModalBooking.palletsShort", language)}.</span>
                                            </Box>
                                            <Box>
                                                <i className="bi bi-box-seam" style={{ marginRight: "5px" }}></i>
                                                <span>{props.YmsbookTask.reduce((sum, task) => sum + (task.CountOfItems || 0), 0)}  {t("ModalBooking.itemsShort", language)}.</span>
                                            </Box>
                                        </Box>
                                    </Box>
                                </div>
                            )}


                        </Box>
                    </>

                ) : (
                    <>
                        <Box className="calendar-status-in-day" display="flex" alignItems="center">
                            <span className="event-status-text" style={{ backgroundColor: "#8D97B0", padding: "6px", borderRadius: '22px' }}> </span>
                            <Typography variant="body2" fontWeight="bold">
                                {format(props.Ymsbook.FromDate, "HH:mm")}
                                {(!props.Ymsbook.ToDate || isNaN(props.Ymsbook.ToDate)) ? '' : ` - ${format(new Date(props.Ymsbook.ToDate), 'HH:mm')}`}
                            </Typography>
                        </Box>

                    </>
                )}

            </div >
            </div>
            {
                !props.isDisabled && (
                    <Menu
                        open={contextMenu !== null}
                        onClose={handleClose}
                        className='calendar-event-menu'
                        anchorReference="anchorPosition"
                        anchorPosition={
                            contextMenu !== null
                                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                : undefined
                        }
                    >
                        {(() => {
                            const canEdit = ((role === "Admin" || role === "Planner") && (Number(props.Ymsbook.Status) < 6 && Number(props.Ymsbook.Status) !== 4)) ||
                                ((role === "Supplier" || role === "3pls") && (Number(props.Ymsbook.Status) <= 3));
                            const canAccept = (role === "Admin" || role === "Planner") && Number(props.Ymsbook.Status) < 4;
                            const canDelete = Number(props.Ymsbook.Status) === 1 || Number(props.Ymsbook.Status) === 3;
                            const canCancel = Number(props.Ymsbook.Status) === 5 || Number(props.Ymsbook.Status) === 2;

                            const noActionsAllowed = !canEdit && !canAccept && !canDelete && !canCancel;

                            return (
                                <>
                                    {canEdit && isTodayOrFutureDate(props.currentDate) && (
                                        <MenuItem onClick={() => handContextMenu("Edit", props.Ymsbook.BookingId)}>
                                            <EditCalendarIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                                            {t("contextMenu.editable", language)}
                                        </MenuItem>
                                    )}
                                    {canAccept && isTodayOrFutureDate(props.currentDate) && (
                                        <MenuItem onClick={() => handContextMenu("Accepted", props.Ymsbook.BookingId)}>
                                            <EventAvailableIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                                            {t("common.accept", language)}
                                        </MenuItem>
                                    )}
                                    {canDelete && (
                                        <MenuItem onClick={() => handContextMenu("Delete", props.Ymsbook.BookingId)}>
                                            <DeleteOutlineOutlinedIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                                            {t("common.delete", language)}
                                        </MenuItem>
                                    )}
                                    {canCancel && (
                                        <MenuItem onClick={() => handContextMenu("cancel", props.Ymsbook.BookingId)}>
                                            <DoDisturbIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                                            {t("common.cancelled", language)}
                                        </MenuItem>
                                    )}
                                    {noActionsAllowed && (
                                        <MenuItem disabled>
                                            {t("calendarEvent.noActions", language)}
                                        </MenuItem>
                                    )}
                                </>
                            );
                        })()}
                    </Menu>
                )
            }
        </>
    );
}

export default CalendarEvent;
